<div class="table-row-count d-inline-block" *ngIf="table.rowCount > 0">
  Displaying {{((table.offset * table.pageSize) + 1).toLocaleString()}}-{{lastItemOffset().toLocaleString()}}
  of {{table.rowCount.toLocaleString()}} entries
</div>
<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'"
                 [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'"
                 [page]="table.offset + 1" [size]="table.pageSize" [count]="table.rowCount" [hidden]="false"
                 (change)="change.emit($event)"  *ngIf="table.rowCount > 0">
</datatable-pager>
